import React, { forwardRef } from "react";
import { ReactNode } from "react";
import { Assign } from "utility-types";
import { ClickableProps } from "../../../clickable";
import { TypeRampV2 } from "../../../typography";
import { DatePickerDayButtonStyledProps, DatePickerDayButtonStyled } from "../styled/DatePickerDayButtonStyled";
import { getTypeRampPropsDay } from "../styled/datePickerTheme";

export interface DatePickerDayProps extends Assign<ClickableProps, DatePickerDayButtonStyledProps> {
    children: ReactNode;
}

export const DAY_STYLED_CLASS_NAME = "lodestar-core--date-picker--day-h3kj2h1";

export const DatePickerDay = forwardRef<HTMLButtonElement, DatePickerDayProps>(({ children, ...rest }, ref) => {
    return (
        <DatePickerDayButtonStyled {...rest} ref={ref}>
            <TypeRampV2 className={DAY_STYLED_CLASS_NAME} {...getTypeRampPropsDay(rest.themeMode)}>
                {children}
            </TypeRampV2>
        </DatePickerDayButtonStyled>
    );
});

DatePickerDay.displayName = "DatePickerDay";
